export const AppStatusBar = () => {
  return null;
};
